import getFirebase from "../../../api/firebase";
import type { UserProfile } from "./types";

export const fetchUserProfile = async (uid: string): Promise<UserProfile> => {
  const firebase = await getFirebase();

  try {
    const doc = await firebase.firestore().collection("users").doc(uid).get();

    const data = doc.data();

    if (!data) {
      throw new Error("User profile not found");
    }

    return data as UserProfile;
  } catch {
    // Return default profile if not found
    return {
      uid,
      email: null,
      name: null,
      photoUrl: null,
      role: "client",
    };
  }
};
